import styled from 'styled-components'

// Common page wrapper with responsive padding
export const PageWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 40px;
	padding: 20px;
	background-color: ${({theme}) => theme.color.white};
	border-radius: 16px;

	@media (min-width: ${({theme}) => theme.breakpoints.mobile}) {
		padding: 40px;
	}

	@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
		gap: 20px;
		padding: 40px 12px;
	}
`

// Common area container for form sections
export const AreaDiv = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;

	& > h2 {
		${({theme}) => theme.font.small_bold};
	}

	@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
		gap: 8px;
	}
`

// Common container for horizontal layouts
export const ContainerDiv = styled.div`
	display: flex;
	gap: 20px;
`

// Common tab container
export const TabDiv = styled.div`
	display: flex;
	gap: 16px;
`

// Common tab button
export const Tab = styled.button`
	${({theme}) => theme.font.small};

	${({$selected, theme}) =>
		$selected &&
		`
			${theme.font.small_bold};
			color: ${theme.color.major};
		`
	}
`

// Common content image
export const ContentImg = styled.img`
	width: 400px;

	@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
		width: 100%;
		max-height: 230px;
	}
`

// Common slider controls
export const SliderDiv = styled.div`
	width: 400px;
	display: flex;
	align-items: center;
	justify-content: end;
	gap: 4px;

	@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
		width: 100%;
		max-height: 230px;
	}

	& > button {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 24px;
		height: 24px;
		background-color: ${({theme}) => theme.color.grey1};
		border-radius: 4px;

		& > img {
			height: 12px;
		}
	}
`

// Common form section wrapper
export const FormSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	width: 100%;
`

// Common button container
export const ButtonContainer = styled.div`
	display: flex;
	gap: 12px;
	justify-content: center;
	flex-wrap: wrap;

	@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
		flex-direction: column;
		gap: 8px;
	}
`

// Common input group
export const InputGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;

	& > label {
		${({theme}) => theme.font.small_bold};
	}
`

// Common horizontal input group
export const HorizontalInputGroup = styled.div`
	display: flex;
	gap: 12px;
	align-items: end;

	@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
		flex-direction: column;
		align-items: stretch;
		gap: 8px;
	}
`

// Enhanced AreaDiv with header styling
export const AreaDivWithHeader = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;

	& > h2 {
		${({theme}) => theme.font.small_bold};

		& > span {
			color: ${({theme}) => theme.color.major};
			${({theme}) => theme.font.small_bold};
		}
	}
`

// Area header with controls
export const AreaHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;

	& > h2 {
		${({theme}) => theme.font.small_bold};

		& > span {
			color: ${({theme}) => theme.color.major};
			${({theme}) => theme.font.small_bold};
		}
	}

	& > div {
		width: fit-content;
		display: flex;
		gap: 8px;
	}
`

// Image upload container
export const ImgUploadDiv = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 16px;
`

// Image element with controls
export const ImgElement = styled.div`
	width: fit-content;
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: end;
	flex-wrap: wrap;
	gap: 6px;

	& > img {
		width: ${({isBanner}) => (isBanner ? '300px' : '120px')};
		height: ${({isBanner}) => (isBanner ? '140px' : '120px')};
		object-fit: cover;
		object-position: center center;
		border-radius: 8px;
		cursor: pointer;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			width: ${({isBanner}) => (isBanner ? '240px' : '120px')};
			height: ${({isBanner}) => (isBanner ? '120px' : '120px')};
		}
	}

	& > button {
		${({theme}) => theme.font.extra_small};
		display: flex;
		align-items: center;
		padding-top: 2px;
	}
`

// Control buttons container
export const ControlDiv = styled.div`
	display: flex;
	justify-content: center;
	gap: 4px;

	& > button {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 24px;
		height: 24px;
		border-radius: 4px;
		background-color: ${({theme}) => theme.color.grey2};
	}
`

// Add button
export const AddBtn = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 20px;
	min-width: 20px;
	height: 20px;
	margin: 0 6px;
	background-color: ${({theme}) => theme.color.grey2};
	border-radius: 9999px;
	align-self: center;

	& > img {
		width: 12px;
	}
`

const CommonStyles = {
	PageWrapper,
	AreaDiv,
	AreaDivWithHeader,
	AreaHeader,
	ContainerDiv,
	TabDiv,
	Tab,
	ContentImg,
	SliderDiv,
	FormSection,
	ButtonContainer,
	InputGroup,
	HorizontalInputGroup,
	ImgUploadDiv,
	ImgElement,
	ControlDiv,
	AddBtn,
}

export default CommonStyles
